// blood pressure category from systolic / diastolic readings (mm Hg), American Heart Association levels
//==============================

export const BP_LIMITS = {
    systolic: { min: 60, max: 250 },
    diastolic: { min: 40, max: 150 },
}

const LOW = { label: 'Low', color: 'blue' }
const NORMAL = { label: 'Normal', color: 'green' }
const ELEVATED = { label: 'Elevated', color: 'gold' }
const STAGE_1 = { label: 'High – Stage 1', color: 'orange' }
const STAGE_2 = { label: 'High – Stage 2', color: 'red' }
const CRISIS = { label: 'Hypertensive Crisis', color: 'magenta' }

// reference table, in the same order as the checks in bpCategory
export const BP_CATEGORY_TABLE = [
    { ...LOW, systolic: 'under 90', join: 'or', diastolic: 'under 60' },
    { ...NORMAL, systolic: 'under 120', join: 'and', diastolic: 'under 80' },
    { ...ELEVATED, systolic: '120 – 129', join: 'and', diastolic: 'under 80' },
    { ...STAGE_1, systolic: '130 – 139', join: 'or', diastolic: '80 – 89' },
    { ...STAGE_2, systolic: '140 or more', join: 'or', diastolic: '90 or more' },
    { ...CRISIS, systolic: 'over 180', join: 'and/or', diastolic: 'over 120' },
]

// category for a reading, or null when either value is missing
// the higher-risk reading decides: e.g. 125/85 is Stage 1 because of the diastolic value
export const bpCategory = (systolicValue, diastolicValue) => {
    const systolic = parseFloat(systolicValue)
    const diastolic = parseFloat(diastolicValue)
    if (!(systolic > 0) || !(diastolic > 0)) return null

    if (systolic > 180 || diastolic > 120) return CRISIS
    if (systolic >= 140 || diastolic >= 90) return STAGE_2
    if (systolic >= 130 || diastolic >= 80) return STAGE_1
    if (systolic >= 120) return ELEVATED
    if (systolic < 90 || diastolic < 60) return LOW
    return NORMAL
}
